// Store de rotación ESCALONADA del carrusel. Un único contador global `step`
// que avanza cada STAGGER_MS (lo dispara el timer en useSlots). El offset de
// cada celda se DERIVA de `step` con un desfase por celda, de modo que en cada
// tick avanza UNA sola celda (round-robin) → las 4 celdas nunca cambian a la
// vez. Además `manual[]` guarda el ajuste manual por celda (botones ◂ ▸), que
// solo cambia con interacción y por eso es estable entre renders (React-safe
// para useSyncExternalStore). `manualEpoch` reinicia el timer tras un click.

type Listener = () => void
const listeners = new Set<Listener>()

let step = 0
let manual: number[] = []
let manualEpoch = 0

function notify() {
  listeners.forEach((l) => l())
}

export function subscribeCarousel(cb: Listener): () => void {
  listeners.add(cb)
  return () => listeners.delete(cb)
}

export function getStep(): number {
  return step
}

export function getManualEpoch(): number {
  return manualEpoch
}

// Offset derivado de la celda `slotIdx` (de `count` celdas de carrusel) para un
// `step` dado: la celda i avanza en los steps ≡ i (mod count), escalonado. Suma
// el ajuste manual de esa celda. Puede ser negativo (botón "anterior");
// useSlots lo normaliza con módulo positivo.
export function slotOffset(step: number, slotIdx: number, count: number): number {
  if (count <= 0) return 0
  const auto = Math.floor((step + (count - 1 - (slotIdx % count))) / count)
  return auto + (manual[slotIdx] ?? 0)
}

// Auto-rotación (timer): un solo paso global → escalona por celda vía slotOffset.
export function autoAdvanceCarousel(): void {
  step += 1
  notify()
}

// Rotación manual (◂ ▸): mueve SOLO esa celda y bumpea el epoch para reiniciar
// el timer (que no auto-rote justo después del click).
export function rotateSlot(slotIdx: number, delta: number): void {
  if (slotIdx < 0) return
  const next = [...manual]
  while (next.length <= slotIdx) next.push(0)
  next[slotIdx] += delta
  manual = next
  manualEpoch += 1
  notify()
}
